import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../constants";

const STORAGE_KEY = "cap_recently_viewed";
const MAX_ITEMS = 12;

/** Push a product_id to localStorage history (called from ProductDetailPage on mount). */
export const trackProductView = (productId) => {
  if (!productId || typeof window === "undefined") return;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    const dedup = [productId, ...list.filter((id) => id !== productId)].slice(0, MAX_ITEMS);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(dedup));
  } catch {
    // ignore quota errors
  }
};

/**
 * Renders a horizontal strip of the user's last-viewed products, excluding the
 * current one. Hides itself if there's nothing meaningful to show.
 */
const RecentlyViewed = ({ excludeProductId }) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const ids = (raw ? JSON.parse(raw) : []).filter((id) => id !== excludeProductId).slice(0, 6);
      if (ids.length === 0) return;
      Promise.all(
        ids.map((pid) => axios.get(`${API}/products/${pid}`).then((r) => r.data).catch(() => null))
      ).then((results) => {
        if (!cancelled) setProducts(results.filter(Boolean));
      });
    } catch {
      // ignore
    }
    return () => { cancelled = true; };
  }, [excludeProductId]);

  if (products.length === 0) return null;

  return (
    <div className="mt-8" data-testid="recently-viewed-section">
      <h2 className="font-heading text-xl tracking-wide mb-4 text-gray-300">RECENTLY VIEWED</h2>
      <div className="flex gap-3 overflow-x-auto pb-2" data-testid="recently-viewed-strip">
        {products.map((p) => (
          <Link
            key={p.product_id}
            to={`/products/${p.product_id}`}
            className="flex-shrink-0 w-32 bg-[#121212] border border-white/5 rounded-sm overflow-hidden hover:border-[#D62828] transition-colors"
            data-testid={`recent-${p.product_id}`}
          >
            <div className="aspect-square bg-[#0A0A0A]">
              <img
                src={p.image_url || "https://images.unsplash.com/photo-1692486407015-3a47e4c1181c"}
                alt={p.name}
                className="w-full h-full object-cover"
                onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1692486407015-3a47e4c1181c"; }}
              />
            </div>
            <div className="p-2">
              <p className="text-white text-xs leading-tight line-clamp-2 mb-0.5">{p.name}</p>
              <p className="text-[#D62828] text-xs font-bold">${p.online_price?.toFixed(2)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;
